import { Component } from '@angular/core';
import {UserService} from '../../services/user.service';
import {Login} from '../../services/user.service';
import { Observable, Subscription } from 'rxjs/Rx';
import {ActivatedRoute, Router } from '@angular/router';
import {CookieService} from 'ng2-cookies';

@Component({
  templateUrl: './oauth.component.html',
  styleUrls: ['./oauth.component.css']
 })
 
export class OauthComponent { 
user: string;
sid: string;

  constructor(private activatedRoute: ActivatedRoute,private userSVC: UserService, private router: Router, private loginInfo : Login, private _cookieService:CookieService){loginInfo = new Login();}

   getCookie(key: string){
       return this._cookieService.get(key);
     }

  ngOnInit() {
      this.sid = this.getCookie("gwt");
   }
}



// WEBPACK FOOTER //
// ./src/app/admin/oauth/oauth.component.ts